import React from 'react';
import { LINKS } from '../config/links';
import { COLORS } from '../utils/constants';

const Header = () => {
  return (
    <header className="text-white shadow-xl" style={{ backgroundColor: COLORS.primary }}>
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <a 
          href={LINKS.HOME_URL} 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-3 hover:opacity-80 transition-opacity"
        >
          <img 
            src={LINKS.LOGO_URL} 
            alt={LINKS.SITE_NAME}
            className="h-9"
            style={{ height: '36px', width: 'auto' }}
          />
        </a>
        
        <div className="flex-1 text-center">
          <h1 className="text-xl md:text-2xl font-bold">{LINKS.APP_NAME}</h1>
          <p className="text-xs md:text-sm opacity-90 mt-1">{LINKS.SITE_NAME}</p>
        </div>
        
        <div className="w-9"></div>
      </div>
    </header>
  );
};

export default Header;